import { useEffect } from "react";
import { useProject } from "../../utils/useProjects";
import { UpdateColorProps, useTheme } from "./useTheme";

interface ColorTheme {
  colorPrimary: string;
  colorSecondary: string;
}

const createColorConfig = (
  theme: ColorTheme,
  prefix: string,
): UpdateColorProps[] => [
  {
    colorHex: theme.colorPrimary,
    colorName: `${prefix}PrimaryColor`,
    generateColorPalette: true,
    overrideColorName: "primaryColor",
  },
  {
    colorHex: theme.colorSecondary,
    colorName: `${prefix}SecondaryColor`,
    generateColorPalette: true,
    overrideColorName: "secondaryColor",
  },
];

export function BrandingAdapter({ children }: React.PropsWithChildren) {
  const { updateColors, resetTheme } = useTheme();
  const { project } = useProject();

  useEffect(() => {
    const settings = project?.settings;
    if (!settings) {
      resetTheme();
      return;
    }

    const themeMap = [
      {
        condition: !!settings.guestMode?.isEnabled,
        theme: settings.guestMode,
        prefix: "guestMode",
      },
      {
        condition:
          settings.theme?.colorPrimary && settings.theme?.colorSecondary,
        theme: settings.theme,
        prefix: "normalMode",
      },
    ];

    const activeRole = themeMap.find(
      (role) =>
        role.condition &&
        role.theme?.colorPrimary &&
        role.theme?.colorSecondary,
    );

    if (activeRole) {
      updateColors(
        createColorConfig(activeRole.theme as ColorTheme, activeRole.prefix),
      );
    } else {
      resetTheme();
    }
  }, [project?.settings, resetTheme, updateColors]);

  return children;
}
